document.addEventListener('DOMContentLoaded', () => {
    var backToTopButton = document.querySelector('[back-to-top]');

    window.onscroll = () => {
        var scrollY = window.pageYOffset || document.documentElement.scrollTop; // For IE compatibility

        if (backToTopButton) {
            // Check if element exists
            if (scrollY > 600) {
                backToTopButton.classList.add('show_me');
            } else {
                backToTopButton.classList.remove('show_me');
            }
        }
    };

    if (backToTopButton) {
        // Check if element exists
        backToTopButton.addEventListener('click', () => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    }
});
